<template>
  <nav></nav>
  <router-view />
  <div class="hover">
    <img
      src="./assets/wx.png"
      alt=""
      @mouseover="showImage"
      @mouseleave="hideImage"
    />
    <span>微信客服</span>
  </div>
  <div v-if="isImageVisible" class="show">
    <img :src="configStore.onlineService" alt="" />
    <span>请使用微信扫一扫</span>
  </div>
</template>

<script setup>
import { ref } from "vue";

import { useConfigStore } from "@/store/index";
const configStore = useConfigStore();

const isImageVisible = ref(false);

const showImage = () => {
  isImageVisible.value = true;
};

const hideImage = () => {
  isImageVisible.value = false;
};
</script>

<style lang="less">
.hover-gesture {
  cursor: pointer !important;
}
.hover-gesture:hover {
  background: linear-gradient(84deg, #3076ff 0%, #7e65ff 100%) !important;
  color: #fff !important;
  // cursor: grabbing;
}

// 弹窗样式
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .video-content {
    background: white;
    padding: 20px;
    border-radius: 12px;
    max-width: 800px;
    width: 100%;
    max-height: 80vh;
    overflow: auto;

    video {
      width: 100%;
      height: auto;
    }

    button {
      margin-top: 10px;
      padding: 10px 20px;
      background: #6358ed;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}

.hover {
  position: fixed;
  right: 20px;
  top: 50%;
  width: 65px;
  height: 65px;
  border-radius: 10px;
  border: 1px solid #dedede;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  gap: 5px;
  color: #666666;
  font-size: 12px;
  text-align: center;
  z-index: 999;

  img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
}

.show {
  position: fixed;
  right: 0;
  top: 50%;
  width: 150px;
  height: 150px;
  border: 1px solid #dedede;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transform: translateY(-155px);
  font-size: 13px;
  z-index: 999;

  img {
    width: 100px;
    height: 100px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 50%;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid #fff;
    z-index: 9;
  }
}
</style>
